import { render, staticRenderFns } from "./AdminTableActionButton.vue?vue&type=template&id=13af589d&scoped=true"
import script from "./AdminTableActionButton.vue?vue&type=script&lang=js"
export * from "./AdminTableActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13af589d",
  null
  
)

export default component.exports